import Bloc from './Bloc.js';
import Types from './Types.js';

export default class SetStatValue extends Bloc {

	constructor (src, ctx) {

		super("setstatvalue", src, ctx, true);
		this.f = (src, ins) => {
			(ins[2] || src).setStatValue(ins[0], ins[1]);
			return [];
		};
		this.types = [Types.string, Types.int, Types.card];
	}
}